import { ResponseMessageData } from './ResponseMessageData'

export class FailureResponseData {
  public ErrorMessage: string
  public DetailedMessages: Array<ResponseMessageData>

  constructor(pErrorMessage: string = 'Unknown Error') {
    this.ErrorMessage = pErrorMessage
    this.DetailedMessages = []
  }
}
